// extracted by mini-css-extract-plugin
module.exports =  {"container":"rIzeJn7","icon":"o4j8BAG"};